import { useCallback, useEffect, useState } from "react";
import { api } from "./api";

/**
 * GET `path` (relative to /api) on mount and whenever it changes.
 * Returns { data, error, loading, reload }. `path` null/undefined = do nothing.
 */
export function useApi(path) {
  const [state, setState] = useState({ data: null, error: null, loading: !!path });
  const [tick, setTick] = useState(0);
  const reload = useCallback(() => setTick(t => t + 1), []);

  useEffect(() => {
    if (!path) return undefined;
    let live = true;
    setState(s => ({ ...s, loading: true, error: null }));
    api.get(path)
      .then(data => { if (live) setState({ data, error: null, loading: false }); })
      .catch(error => { if (live) setState({ data: null, error, loading: false }); });
    return () => { live = false; };
  }, [path, tick]);

  return { ...state, reload };
}
